<template>
	<button
		type="button"
		v-if="vIf()"
		:disabled="disabled() || loading"
		@click="action"
	>
		<template v-if="loading">
			<i class="fa fa-spin fa-spinner"></i>
			Enviando
		</template>
		<template v-else>
			<i :class="icon"></i>
			{{ text }}
		</template>
	</button>
</template>
<script>
	export default {
		props: ['vIf', 'icon', 'text', 'loading', 'disabled'],
		methods: {
			action() {
				if (!this.loading) this.$emit('click');
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/create-form/components/action-button.vue